import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@premotec/pmt-essentials';

import { environment } from '../../../../environments/environment';
import { UserAuthorizationService } from '../../../security/services/user-authorization.service';
import { IdpDemoCodeResponeModel } from './idp-demo-code-respone.model';
import { IdpDemoService } from './idp-demo.service';

@Component({
    selector: 'app-top-navbar',
    templateUrl: './top-navbar.component.html',
    styleUrls: ['./top-navbar.component.scss']
})
export class TopNavbarComponent extends BaseComponent implements OnInit {

    username: string | null = null;
    isLoggedIn: boolean | null = null;

    protected staffToolUrl = environment.staffToolUrl;
    protected isAdmin = false;

    constructor(
        private authService: UserAuthorizationService,
        private idpDemoService: IdpDemoService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.checkLoginAndSetUserInfos();
    }

    protected logout() {
        this.authService.logout();
    }

    protected directRedirectLoginToStaffTool(): void {
        let userId = this.authService.getUser()?.imId!;
        this.idpDemoService.getHandOffToken().subscribe({
            next: (x: IdpDemoCodeResponeModel) => {
                this.idpDemoService.openStaffToolWithHandoff(x.code, userId);
            }
        });

    }

    private checkLoginAndSetUserInfos(): void {
        this.authService.isLoggedIn().then((isLoggedIn) => {
            this.isLoggedIn = isLoggedIn;
            if (!isLoggedIn) return;

            var user = this.authService.getUser();
            if (user.given_name != undefined) {
                this.username = user.given_name;
                this.isAdmin = user.isAdmin();
            }

        });
    }
}